module.exports = __webpack_public_path__ + "img/x.1c23e00d.png";